import { inject, Injectable } from '@angular/core';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { firstValueFrom } from 'rxjs';
import { TitleAndFileNames } from 'src/app/content/_components/_shared/mediaviewmodal/mediaviewmodal.component';
import {
  FileByNameFn,
  FilesByNamesFn,
  MediaApiFunc,
  TitleAndFilePath,
} from 'src/app/services/MediaApiFunc/abstract-media-api-func';
import { WartungApiService } from '../APIService/wartung.api.service';

@Injectable({
  providedIn: 'root',
})
export class WartungMediaApiFuncService extends MediaApiFunc {
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly api = inject(WartungApiService);

  constructor() {
    super();
  }

  parseMediaPath(wartung?: string): TitleAndFileNames[] {
    let fileNamesWithTitle: TitleAndFileNames[] = [];

    if (wartung)
      fileNamesWithTitle.push({
        title: 'Wartung',
        fileNames: wartung.split('|').filter(bild => bild != ''),
      });

    return fileNamesWithTitle;
  }

  override parseMediaPathWithTitle(titled?: TitleAndFilePath): TitleAndFileNames[] {
    let fileNamesWithTitle: TitleAndFileNames[] = [];

    if (titled)
      fileNamesWithTitle.push({
        title: `Wartung ${titled.title}`,
        fileNames: titled.filepath.split('|').filter(bild => bild != ''),
      });

    return fileNamesWithTitle;
  }

  getApiFunctionMedia: FilesByNamesFn = async fileNames => {
    if (!fileNames?.length) return [];
    const { success, files, error } = await firstValueFrom(this.api.getWartungMediaAllByNames(fileNames));
    if (!success)
      throw new Error(
        this.mrTranslate.transform('Die Dateien konnten nicht geladen werden!') +
          ' ' +
          this.mrTranslate.transform(error)
      );
    return files;
  };

  getApiFunctionMediaBig: FileByNameFn = async name => {
    if (!name) return;
    const base64 = await firstValueFrom(this.api.getWartungMediaByName(name));
    if (!base64) throw new Error(this.mrTranslate.transform('Die Datei konnte nicht geladen werden!'));
    return base64;
  };
}
